import script from "./CoeView.vue?vue&type=script&setup=true&lang=js"
export * from "./CoeView.vue?vue&type=script&setup=true&lang=js"

import "./CoeView.vue?vue&type=style&index=0&id=10229f38&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-melindacvc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10229f38"]])

export default __exports__